<template>
  <scoped>
    <VerticalNavigator>
      <Breadcrumb
        :links="[{
          title: 'RutSolve',
          routeName: 'index'
        }]"
        title="Finances"
      />
      <h1>
        Finances
      </h1>
      <DateInput
        v-model:value="periodStart"
        title="Period Start"
      />
      <DateInput
        v-model:value="periodEnd"
        title="Period End"
      />
      <Button
        title="Load Finances"
        @click="read()"
      />
      <ErrorModal
        v-if="error"
        v-model:error="error"
      />
      <div v-if="finances">
        <h2>
          Overview
        </h2>
        <table>
          <tbody>
            <tr>
              <th>
                Gross Profit
              </th>
              <td>
                <template v-if="finances.profitGross">
                  {{ finances.profitGross.toFixed(2) }}
                </template>
              </td>
            </tr>
            <tr>
              <th>
                Net Profit
              </th>
              <td>
                <template v-if="finances.profitNet">
                  {{ finances.profitNet.toFixed(2) }}
                </template>
              </td>
            </tr>
            <tr>
              <th>
                Gross Revenue
              </th>
              <td>
                <template v-if="finances.revenueGross">
                  {{ finances.revenueGross.toFixed(2) }}
                </template>
              </td>
            </tr>
            <tr>
              <th>
                Net Revenue
              </th>
              <td>
                <template v-if="finances.revenueNet">
                  {{ finances.revenueNet.toFixed(2) }}
                </template>
              </td>
            </tr>
            <tr>
              <th>
                Gross Cost
              </th>
              <td>
                <template v-if="finances.costGross">
                  {{ finances.costGross.toFixed(2) }}
                </template>
              </td>
            </tr>
            <tr>
              <th>
                Net Cost
              </th>
              <td>
                <template v-if="finances.costNet">
                  {{ finances.costNet.toFixed(2) }}
                </template>
              </td>
            </tr>
          </tbody>
        </table>
        <h2>
          VAT
        </h2>
        <table>
          <thead>
            <tr>
              <th>
                Rate
              </th>
              <th>
                Revenue
              </th>
              <th>
                Cost
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="vat in finances.vat"
              :key="vat.rate"
            >
              <td>
                <template v-if="vat.rate">
                  {{ vat.rate.toFixed(2) }}%
                </template>
              </td>
              <td>
                <template v-if="vat.revenue">
                  {{ vat.revenue.toFixed(2) }}
                </template>
              </td>
              <td>
                <template v-if="vat.cost">
                  {{ vat.cost.toFixed(2) }}
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </VerticalNavigator>
  </scoped>
</template>

<script setup lang="ts">
  import Breadcrumb from "@/components/breadcrumb.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import {Finance as FinanceClient} from "@/endpoints/rutsolve/gql/resolvers/finance"
  import {ref} from "vue"
  import {FinanceResponse} from "@/endpoints/rutsolve/gql/generated/graphql"
  import ErrorModal from "@/components/modals/error.vue"
  import DateInput from "@/components/inputs/date.vue"
  import Button from "@/components/button.vue"

  const error = ref<Error>(null)
  const financeClient = new FinanceClient()
  const finances = ref<FinanceResponse>(null)
  const periodEnd = ref<string>(null)
  const periodStart = ref<string>(null)

  async function read() {
    try {
      finances.value = await financeClient.overview({
        periodEnd: periodEnd.value,
        periodStart: periodStart.value,
      })
    } catch(e) {
      error.value = e
    }
  }
</script>

<style scoped>
</style>
